/** Helpers UI — asignaciones cliente operativo ↔ staff (Fase 2E). */

export const DESPACHO_NO_ASSIGNED_CLIENTS_MESSAGE =
  "No tienes clientes asignados todavía.";

export const DESPACHO_NO_STAFF_FOR_ASSIGNMENT_MESSAGE =
  "Primero da de alta usuarios del despacho.";

/**
 * @param {Array<{ user_id?: string, name?: string, despacho_role?: string, role_on_client?: string }>} assignedUsers
 */
export function formatAssignedUsersLabel(assignedUsers) {
  if (!Array.isArray(assignedUsers) || assignedUsers.length === 0) {
    return "Sin asignar";
  }
  return assignedUsers
    .map((u) => u.name || u.user_id || "—")
    .filter(Boolean)
    .join(", ");
}

/**
 * @param {object | null | undefined} user
 */
export function isDespachoAssignmentScopedUser(user) {
  const profileRole = String(user?.despacho_profile?.despacho_role || "").toLowerCase();
  return profileRole === "auxiliar" || profileRole === "consulta";
}

/**
 * @param {Array<{ id?: string, status?: string }>} staffRows
 */
export function activeStaffForAssignment(staffRows) {
  return (staffRows || []).filter((s) => (s.status || "active") === "active" && s.id);
}

/**
 * @param {Array<{ user_id?: string }>} assignedUsers
 * @param {string[]} selectedIds
 */
export function buildAssignmentsPayload(selectedIds) {
  return selectedIds.map((user_id) => ({ user_id, role_on_client: "primary" }));
}

/**
 * @param {Array<{ user_id?: string }>} assignedUsers
 */
export function assignedUserIds(assignedUsers) {
  return (assignedUsers || []).map((u) => u.user_id).filter(Boolean);
}
